// extracted by mini-css-extract-plugin
export default {"container":"QO-z","darkBackground":"RO-z","whiteBackground":"SO-z","headerButton":"TO-z","calloutHeading":"UO-z","calloutSubHeading":"VO-z"};